// import * as apis from '@apis'

const UserManage = {
  namespaced: true,
  state: {
    metadata: {
      'mod': 'rr-user',
      'org': 0
    }
  },
  getters: {},
  mutations: {
  },
  actions: {
  }
}

export default UserManage
